import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
export const footerInfoLogo=[
    {
        description:'Welcome to our carefully curated collection—premium'
    }
];
export const footerInfoContact=[
    {
        icon:faPhone,
        contact:'+963991333348',
        Link:'tel:+963991333348'
    },
    {
        icon:faEnvelope,
        contact:'alimhasan.9933@gmail.com',
        Link:'mailto:alimhasan.9933@gmail.com'
    }
];

